"use strict";

exports.__esModule = true;
exports.ImageWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _ImageElement = require("./ImageElement");
var _ImageFields = require("./ImageFields");
var _ImageThumbnail = require("./ImageThumbnail");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ImageWidget = exports.ImageWidget = {
  name: "ImageWidget",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "ImageWidget.label",
    defaultMessage: "Image"
  }),
  icon: "media",
  createElement: function createElement(props) {
    return {
      type: "ImageWidget",
      props: Object.assign({
        width: 256,
        height: 256
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: false,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: [],
  requiresProps: ["x", "y", "width", "height", "image", "opacity", "imageFit"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 256,
      min: 32,
      max: 1024
    },
    height: {
      "default": 256,
      min: 32,
      max: 768
    }
  },
  components: {
    Element: _ImageElement.ImageElement,
    Fields: _ImageFields.ImageFields,
    Thumbnail: _ImageThumbnail.ImageThumbnail
  }
};